function PillTabs({ options, value, onChange, ariaLabel }) {
    return (
        <div
            role="tablist"
            aria-label={ariaLabel}
            className="flex items-center gap-1 rounded-xl bg-muted p-1"
        >
            {options.map(({ value: optValue, label }) => {
                const active = optValue === value;
                return (
                    <button
                        key={optValue}
                        type="button"
                        role="tab"
                        aria-selected={active}
                        onClick={() => onChange(optValue)}
                        className={`px-3 py-1.5 text-sm rounded-lg ${
                            active
                                ? 'bg-card shadow-sm text-primary'
                                : 'text-foreground hover:bg-muted-foreground/10'
                        }`}
                    >
                        {label}
                    </button>
                );
            })}
        </div>
    );
}

export default PillTabs;
